import React, { useEffect, useCallback, useState } from "react";
import { Modal, Spin } from 'antd';
import CoreBadge from '../CoreBadge/CoreBadge.jsx'
import {
	FacebookIcon,
	FacebookShareButton,
	LinkedinIcon,
	LinkedinShareButton,
	TwitterShareButton,
	XIcon,
} from 'react-share';
import './viewRewardModal.scss'
import { addCommas } from "../../rewardsAndRecognitionHelper/utils.js";
import { useSelector } from "react-redux";
import { MAPPED_BADGE_TYPE } from "../CoreBadge/rewardsConstants.js";
import { fetchModernFormQuestions } from "src/_shared/services/utils.js";

const ViewRewardModal = (props) => {
  const { isViewRewardModalVisible, handleCloseViewReward, rewardDetails, isModalLoaderVisible, isSharingVisible } = props;
  const [isLoading, setIsLoading] = useState(false);
  const [formData, setFormData] = useState(null);
  const shareURL = rewardDetails?.image;
  const currentUser = useSelector(state => state.user.currentUser);
  const rewardsEarnedMechanism = currentUser?.company?.recognitionSettings?.rewardsEarnedMechanism;
  const showSnappy = rewardsEarnedMechanism === 'recognition';


  useEffect(() => {
      if (!isLoading && !formData) {
        const awaitFormData = async () => {
          try {
            setIsLoading(true);
            const awaitedFormData = await fetchModernFormQuestions(				
              currentUser,
              'custom',
              'manager_justification_form'
            ) || {};
            setFormData(awaitedFormData);
          } catch (e) {
            throw e;
          } finally {
            setIsLoading(false);
          }	
        };					
        awaitFormData();
      }
    }, [rewardDetails?.companyId]);
  
    const getJustificationContent = useCallback((justificationData = null) => {
      if (justificationData === null) return [];
      const parsedJustificationData = JSON.parse(justificationData);
      const content = [];
      const validElements = ['input','textarea','select'];
      formData?.elements?.forEach(ele => {
        if (validElements.includes(ele?.type)) {
          const answer = parsedJustificationData?.[ele.id] || "";
          content.push({question: ele?.label, answer});
        }
      });
      return content;
    }, [formData]);

    const selectedJustification = getJustificationContent(rewardDetails?.justificationFormAnswers);



  return <>
    <Modal
      open={isViewRewardModalVisible}
      onCancel={handleCloseViewReward}
      footer={false}
      width={600}
    >
      {
        isModalLoaderVisible ?
          <div className="d-flex align-items-center justify-content-center w-100 h-100"> <Spin /> </div> :
          rewardDetails && <div className="physical-reward-modal">
            <div className='row w-100'>
              <div className='col-sm-5 col-12'>
                <div style={{
                  height: isSharingVisible ? "auto" : "100%"
                }} className="physical-reward-badge">
                  {rewardDetails?.badgeType ? <CoreBadge
                    badgeType={rewardDetails?.badgeType}
                    badgeIcon={rewardDetails?.iconInfo?.code}
                    label={rewardDetails?.label}
                    color={rewardDetails?.color}
                    gradientColor={rewardDetails?.gradientColor}
                  /> : <></>}
                </div>
                {isSharingVisible ?
                  <>
                    <div className="d-flex justify-content-center">
                      <p className="physical-reward-details-semi-title">
                        Tell Others About Your Recognition
                      </p>
                    </div>

                    <div className="physical-social-icon d-flex align-items-center justify-content-center">
                      <div>
                        <LinkedinShareButton
                          style={{ cursor: 'pointer', textAlign: 'center', marginRight: '6px' }}
                          url={shareURL}
                          title='Check out this recognition:'
                        >
                          <LinkedinIcon round alt="LinkedIn" size={32} />
                        </LinkedinShareButton>
                      </div>
                      <div className="">
                        <FacebookShareButton
                          style={{ cursor: 'pointer', textAlign: 'center', marginRight: '6px' }}
                          url={shareURL}
                          quote='Check out this recognition:'
                        >
                          <FacebookIcon round alt="Facebook" size={32} />
                        </FacebookShareButton>
                      </div>
                      <div className="">
                        <TwitterShareButton
                          style={{ cursor: 'pointer', textAlign: 'center' }}
                          url={shareURL}
                          title='Check out this recognition:'
                        >
                          <XIcon round alt="X" size={32} />
                        </TwitterShareButton>
                      </div>
                    </div>
                  </>
                  : null}
              </div>
              <div className='col-sm-7 col-12'>
                <div className="physical-reward-details">
                  <h4 className="physical-reward-text">
                  <>{rewardDetails?.badgeTypeCode === MAPPED_BADGE_TYPE.AUTOMATED ? `${rewardDetails?.companyName} ` : ""}</>{rewardDetails?.name}
                  </h4>
                  <p className="physical-reward-details line-clamp-three">
                    {rewardDetails?.description}
                  </p>
                  <div className="award-detalis">
                    <div className="award-detalis-info" style={{justifyContent: 'center', marginBottom: 24, flexDirection: 'column', textAlign: 'center'}}>
                      <div className="award-detalis-about pr-4">
                        <span className="award-detalis-name pr-2">Earned Date:</span>
                        <span className="award-detalis-numbers">
                          {rewardDetails?.earnedDate
                            ? new Date(rewardDetails.earnedDate).toLocaleDateString('en-US', {
                                month: '2-digit',
                                day: '2-digit',
                                year: 'numeric'
                              })
                            : 'N/A'
                          }
                        </span>
                      </div>
                      {rewardDetails?.awardedByUser ? (
                        <div className="award-detalis-about pr-4">
                          <span className="award-detalis-name pr-2">Recognized by:</span>
                          <span className="award-detalis-numbers"> {rewardDetails?.awardedByUser?.firstName + " " + rewardDetails?.awardedByUser?.lastName}</span>
                        </div>
                      ) : null}
                      {rewardDetails?.isBadgeAssignment ? null : (
                      <div className="award-detalis-about">
                        <span className="award-detalis-name pr-2">{showSnappy ? "Reward" : "Points"}:</span>
                        <span className="award-detalis-numbers">{showSnappy ? '$' + (addCommas(rewardDetails?.snappyGrant?.costInCurrency) || '0') : addCommas(rewardDetails?.points || 0)}</span>
                      </div>)}
                    </div>
                    <div style={{padding: '0 12px', fontSize: '16px'}}>
                      {selectedJustification && Array.isArray(selectedJustification) ? selectedJustification.map((j, i) => (
                        (
                          <div key={i}>
                            <span style={{color: 'rgba(0, 0, 0, 0.85)'}}>
                              <strong>{j?.question ? j.question + ':' : 'Question:'}</strong>
                            </span>
                            <p style={{color: 'rgba(0, 0, 0, 0.75)'}}>
                              {j?.answer || 'No answer provided'}
                            </p>
                          </div>
                        )
                      )) : (
                        null
                      )}
                    </div>
                    {rewardDetails?.isBadgeAssignment ? null :
                      <p className="text-gray line-clamp-three">
                        {showSnappy ? rewardDetails?.snappyGrant?.description :
                        `Only ${rewardDetails?.issuedBadgePercentage || 0}% employess have earned this recognition!`}
                      </p>
                    }
                  </div>
                </div>
              </div>
            </div>
          </ div>
      }
    </Modal>
  </>;
};

export default ViewRewardModal;
